import { Component, input } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { WorkbenchBreadcrumbConfig } from '@app/models/breadcrumb.model';

@Component({
  selector: 'app-workbench-page',
  templateUrl: './workbench-page.component.html',
  styleUrls: ['./workbench-page.component.scss'],
  standalone: false
})
export class WorkbenchPageComponent {
  readonly jobsMenu = input<MatMenu>();
  readonly invoicesMenu = input<MatMenu>();
  readonly mainAriaLabelledby = input<string>();
  readonly breadcrumb = input<WorkbenchBreadcrumbConfig>();
}
